<template>
  <div>
    <v-btn
      icon
      color="white"
      @click="doShare()"
    >
      <v-icon>mdi-share-variant</v-icon>
    </v-btn>

    <v-dialog
      v-model="show"
      width="500"
    >
      <v-card>
        <div
          v-if="false"
          class="sh-card"
          :style="{ backgroundImage: `url('${trip.image}')` }"
        >
          <div class="sh-card__filter" />
          <div class="sh-card__title">
            {{ trip.name }}
          </div>
        </div>

        <v-container fluid>
          <social-sharing
            :title="title"
            :description="description"
            hashtags="vjago,travel"
            inline-template
          >
            <v-row class="social-buttons">
              <v-col cols="4">
                <network network="email">
                  <v-icon
                    large
                  >
                    mdi-email
                  </v-icon>
                </network>
              </v-col>

              <v-col cols="4">
                <network network="facebook">
                  <v-icon
                    large
                  >
                    mdi-facebook-box
                  </v-icon>
                </network>
              </v-col>

              <v-col cols="4">
                <network network="linkedin">
                  <v-icon
                    large
                  >
                    mdi-linkedin-box
                  </v-icon>
                </network>
              </v-col>

              <v-col cols="4">
                <network network="odnoklassniki">
                  <v-icon
                    large
                  >
                    mdi-odnoklassniki
                  </v-icon>
                </network>
              </v-col>

              <v-col cols="4">
                <network network="pinterest">
                  <v-icon
                    large
                  >
                    mdi-pinterest
                  </v-icon>
                </network>
              </v-col>

              <v-col cols="4">
                <network network="reddit">
                  <v-icon
                    large
                  >
                    mdi-reddit
                  </v-icon>
                </network>
              </v-col>

              <v-col cols="4">
                <network network="skype">
                  <v-icon
                    large
                  >
                    mdi-skype
                  </v-icon>
                </network>
              </v-col>

              <v-col cols="4">
                <network network="telegram">
                  <v-icon
                    large
                  >
                    mdi-telegram
                  </v-icon>
                </network>
              </v-col>

              <v-col cols="4">
                <network network="twitter">
                  <v-icon
                    large
                  >
                    mdi-twitter
                  </v-icon>
                </network>
              </v-col>

              <v-col cols="4">
                <network network="vk">
                  <v-icon
                    large
                  >
                    mdi-vk
                  </v-icon>
                </network>
              </v-col>

              <v-col>
                <network network="weibo">
                  <v-icon
                    large
                  >
                    mdi-sina-weibo
                  </v-icon>
                </network>
              </v-col>

              <v-col cols="4">
                <network network="whatsapp">
                  <v-icon
                    large
                  >
                    mdi-whatsapp
                  </v-icon>
                </network>
              </v-col>
            </v-row>
          </social-sharing>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Trip from '@/models/Trip'

export default {
  props: {
    trip: {
      type: Trip,
      default: () => new Trip(),
      required: true
    }
  },
  data () {
    return {
      description: `Hey take a look at ${this.trip.name} on Vjago`,
      show: false,
      title: `Trip ${this.trip.name} - Vjago`
    }
  },
  methods: {
    doShare () {
      if (navigator.share) {
        navigator.share({
          title: this.title,
          text: this.description,
          url: `https://vjago-app.web.app/trips/${this.trip.id}`
        })
      } else {
        this.show = true
      }
    }
  }
}
</script>

<style lang="scss">
.social-buttons {
  .col {
    text-align: center;
  }

  i {
    cursor: pointer;
    margin: 0 2px;
  }
}

.sh-card {
  position: relative;
  width: 800px;
  height: 400px;
  padding: 20px;
  background-repeat: no-repeat;
  background-size: cover;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.sh-card__title {
  position: relative;
  font-family: 'Roboto';
  font-size: 100px;
  text-align: center;
  color: white;
  text-shadow: 2px 2px 11px black;
}
.sh-card__filter {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
</style>
